import { dataHooks } from '../../../../libs/dataHooks';

export const featuresFilterDataHooks = dataHooks<{
  filterItem: { id: string };
}>('features-filters');
